import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiSettings } from '../config/api-settings';

@Injectable({ providedIn: 'root' })
export class PlaygroundAssistService {
  constructor(private http: HttpClient) {}

  optimizePrompt(question: string, endpoint: 'rag' | 'answer'): Observable<string> {
    const URL = `${ApiSettings.fullPath}playground/optimize_prompt`;

    return this.http.post<{ optimized_question: string }>(URL, { question, endpoint }).pipe(
      map(res => res.optimized_question),
    );
  }
}
